import { ItemCardTier } from "types/item-cards/item-card-definition";
import type { ItemCardDefinition } from "types/item-cards/item-card-definition";

/**
 * Keys with dedicated pixel art dropped in `/assets/dev/card-lab/` so far
 * (~15 of 71 item cards). Everything else falls back to a per-tier
 * placeholder icon until real art is produced for the rest of the catalog.
 */
const CARD_ICON_KEYS = new Set([
  "agile_boots",
  "banner",
  "barrier",
  "cheri_berry",
  "fire_a_charcoal",
  "focus_band",
  "full_heal",
  "hyper_potion",
  "leftovers",
  "lum_berry",
  "rare_candy",
  "scope_lens",
  "sitrus_berry",
  "super_potion",
  "vitamin",
]);

const TIER_FALLBACK_ICON: Record<ItemCardTier, string> = {
  [ItemCardTier.FREE]: "/assets/items/fallback/free.svg",
  [ItemCardTier.SUSTAIN]: "/assets/items/fallback/sustain.svg",
  [ItemCardTier.BUFF]: "/assets/items/fallback/buff.svg",
  [ItemCardTier.TYPED]: "/assets/items/fallback/typed.svg",
};

/** Resolves an item card's icon, falling back to a generic per-tier placeholder. */
export const getItemCardIconUrl = (def: ItemCardDefinition): string =>
  CARD_ICON_KEYS.has(def.key)
    ? `/assets/dev/card-lab/${def.key}.png`
    : TIER_FALLBACK_ICON[def.tier];
